import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'


// Accounts
import AccountsDashboardPage from '../app/accounts/dashboard/pages/AccountsDashboardPage'
import FeeStructureListPage from '../app/accounts/feeStructure/pages/FeeStructureListPage'
import StaffCollectionReportPage from '../app/accounts/reports/pages/StaffCollectionReportPage'
import DepartmentCollectionReportpage from '../app/accounts/reports/pages/DepartmentCollectionReportpage'
import AccountsTransactionReportPage from '../app/accounts/reports/pages/AccountsTransactionReportPage'
import PatientPendencyReportPage from '../app/accounts/reports/pages/PatientPendencyReportPage'


function AccountsRoutes() {
  return (
    <Routes>
        {/* Accounts */}
        <Route path="/accounts/dashboard" element={<AccountsDashboardPage />}></Route>
        <Route path="/accounts/fee-structure" element={<FeeStructureListPage />}></Route>
        <Route path="/accounts/reports/staff-collection" element={<StaffCollectionReportPage />}></Route>
        <Route path="/accounts/reports/department-collection" element={<DepartmentCollectionReportpage />}></Route>
        <Route path="/accounts/reports/transactions" element={<AccountsTransactionReportPage />}></Route>
        <Route path="/accounts/reports/patient-pendency" element={<PatientPendencyReportPage />}></Route>
    </Routes>
  )
}

export default AccountsRoutes